import { render, staticRenderFns } from "./NewOrganizationForm.vue?vue&type=template&id=fdf7522c&scoped=true"
import script from "./NewOrganizationForm.vue?vue&type=script&lang=js"
export * from "./NewOrganizationForm.vue?vue&type=script&lang=js"
import style0 from "./NewOrganizationForm.vue?vue&type=style&index=0&id=fdf7522c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf7522c",
  null
  
)

export default component.exports